export default __webpack_public_path__ + "static/look-cd828bfeea5ed44ce8f5f8552da734fe.png";